module.exports = __webpack_public_path__ + "static/yieldr@2x-3692cfef2020f4587d1d45e0f8f80811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/yieldr@2x.jpg
// module id = 874
// module chunks = 33019919093843 122353984331245